import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './CaseStudies.scss';

/**
 * CaseStudies component for MET Connect® website
 * 
 * Showcases industry-specific case studies demonstrating 
 * how MET Connect® solutions are applied in different sectors
 * 
 * @returns {JSX.Element} The CaseStudies component
 */
const CaseStudies = () => {
  /**
   * Case study data for different industries
   */
  const caseStudies = [
    {
      id: 'cement',
      title: 'Cement Industry',
      image: 'small-cement-plant.jpg',
      description: 'MET Connect® assists Cement Australia Pozzolanic Group by allowing them remote control over their Ash Classifier Plants at several of Queensland\'s Coal Power Stations.',
      link: '/case-studies/cement-industry'
    },
    {
      id: 'crushing',
      title: 'Rock Crushing',
      image: 'small-crusher.jpg',
      description: 'For a growing number of rock crushing companies in Australia, MET Connect® is becoming operationally essential. Their remotely located engineers are monitoring the plants essential parameters and make plant configuration changes within the PLC on-the-fly.',
      link: '/case-studies/rock-crushing'
    },
    {
      id: 'manufacturing',
      title: 'Manufacturing',
      image: 'small-industrial.jpg',
      description: 'Within the manufacturing industry MET Connect® is significantly reducing downtime and support staff travel cost by allowing remotely located support Engineers to remotely diagnose and rectify control system issues.',
      link: '/case-studies/manufacturing'
    },
    {
      id: 'marine',
      title: 'Marine',
      image: 'small-marine.jpg',
      description: 'Within the Super yacht industry MET Connect® is enabling real-time parameter monitoring of the yachts engine data and Vessel Management System PLC Networks by shore-based support Engineers.',
      link: '/case-studies/marine'
    }
  ];

  return (
    <section className="case-studies-section" id="case-studies">
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto">
            <h2 className="section-title">Industry Case Studies</h2>
            <p className="section-subtitle">
              Discover how MET Connect® solutions are helping businesses across various industries 
              improve their operations and reduce costs.
            </p>
          </Col>
        </Row>
        
        <Row className="case-studies-row">
          {caseStudies.map((study, index) => (
            <Col lg={6} xl={3} key={study.id} className="mb-4">
              <Card className="case-study-card h-100">
                <div className="case-study-image">
                  <img 
                    src={`/images/${study.image}`} 
                    alt={study.title} 
                    className="img-fluid" 
                  />
                  <div className="image-overlay">
                    <h3>{study.title}</h3>
                  </div>
                </div>
                <Card.Body>
                  <Card.Text>{study.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CaseStudies;